import { Suspense, lazy } from 'react'
import { CrtBlockProgress } from '../../../components/crt'
import { useSceneStore } from '../sceneStore'

const panelMap = {
  auth: lazy(() => import('../panels/auth')),
  draft: lazy(() => import('../panels/draft')),
  integrations: lazy(() => import('../panels/integrations')),
  billing: lazy(() => import('../panels/billing')),
  tickets: lazy(() => import('../panels/tickets')),
  oauth: lazy(() => import('../panels/OAuthPanel')),
  choice: lazy(() => import('../panels/UserChoicePanel')),
  sensitive: lazy(() => import('../panels/SensitivePanel')),
  context: lazy(() => import('../panels/ContextSelectPanel')),
  sessions: lazy(() => import('../panels/sessions')),
  'platform-admin': lazy(() => import('../panels/PlatformAdminPanel')),
}

function PanelFallback() {
  return (
    <div className="scene-panel-loading">
      <CrtBlockProgress progress={45} label="LOADING MODULE" />
    </div>
  )
}

export function ScenePanelRouter({ sceneProps }) {
  const panel = useSceneStore((s) => s.panel)
  const transition = useSceneStore((s) => s.transition)
  const PanelComponent = panel ? panelMap[panel] : null

  if (!PanelComponent) return null

  return (
    <div className={`scene-panel-slot ${transition === 'panelOut' ? 'is-closing' : ''}`}>
      <Suspense fallback={<PanelFallback />}>
        <PanelComponent {...sceneProps} />
      </Suspense>
    </div>
  )
}
